import { Component } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-user-copy',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './add-user.component.html',
  styleUrl: './add-user.component.scss'
})
export class AddUserCopyComponent {
showPassword = false;

addUserObj:any ={
  firstName: '',
  lastName: '',
  mobileNumber: '',
  emailAddrs: '',
  password: '',
  confirmPassword: '',
  designation: '',
  siteLocation: '',
  city: '',
  state: '',
  role: ''  
  }
  formValue:any;

  onSubmit(){
    this.formValue = this.addUserObj;
    console.log(this.formValue);
  }
}
